export default "__VITE_ASSET__Bd0q0SDm__"